import { render, staticRenderFns } from "./similarImageReviewPage.vue?vue&type=template&id=71e22672&scoped=true"
import script from "./similarImageReviewPage.vue?vue&type=script&lang=js"
export * from "./similarImageReviewPage.vue?vue&type=script&lang=js"
import style0 from "./similarImageReviewPage.vue?vue&type=style&index=0&id=71e22672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e22672",
  null
  
)

export default component.exports